import { CommonModule } from '@angular/common';
import {
  AfterViewInit,
  Component,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Play } from '../interfaces/efficiency-report.interface';

@Component({
  selector: 'og-efficiency-report-print',
  imports: [CommonModule],
  templateUrl: './efficiency-report-print.component.html',
  styleUrls: ['./efficiency-report-print.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  encapsulation: ViewEncapsulation.None,
})
export class EfficiencyReportPrintComponent implements OnInit, OnDestroy, AfterViewInit {
  columnDefs = [
    {
      field: 'series_seq',
      headerName: 'P&10',
    },
    {
      field: 'down1',
      headerName: '1st Down',
    },
    {
      field: 'down2_dist_1_3',
      headerName: '2nd & 1-3',
    },
    {
      field: 'down2_dist_4_6',
      headerName: '2nd & 4-6',
    },
    {
      field: 'down2_dist_7_10',
      headerName: '2nd & 7-10',
    },
    {
      field: 'down2_dist_11',
      headerName: '2nd & 11+',
    },
    {
      field: 'down3_dist_1_3',
      headerName: '3rd & 1-3',
    },
    {
      field: 'down3_dist_4_6',
      headerName: '3rd & 4-6',
    },
    {
      field: 'down3_dist_7_10',
      headerName: '3rd & 7-10',
    },
    {
      field: 'down3_dist_11',
      headerName: '3rd & 11+',
    },
    {
      field: 'down4',
      headerName: '4th Down',
    },
    {
      field: 'down5',
      headerName: '2PT. Conv',
    },
    {
      field: 'efficiency',
      headerName: 'Total',
    },
  ];
  rowData: Play[] = [];
  isCapturing = false;

  constructor() {}

  ngOnInit(): void {
    const rowData = sessionStorage.getItem('rowData');
    this.rowData = rowData ? JSON.parse(rowData) : [];

    window.onafterprint = () => {
      document.title = 'Optimum Grading';
      window.close();
    };
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      document.title = 'Efficiency Report';
      window.print();
    }, 500);
  }

  getEfficiencyClass(fieldValue: any, headerName: string, cellName: string): string {
    if (
      !fieldValue ||
      cellName === 'Grand Total' ||
      headerName === 'Efficiency Total' ||
      !fieldValue.total_plays
    ) {
      return '';
    }

    const pct = fieldValue.pct;

    if (pct >= 0 && pct < 60) return 'red-cell';
    if (pct >= 60 && pct < 70) return 'orange-cell';
    if (pct >= 70 && pct < 80) return 'yellow-cell';
    if (pct >= 80 && pct < 90) return 'green-cell';
    if (pct >= 90 && pct <= 100) return 'darkGreen-cell';

    return '';
  }

  ngOnDestroy(): void {
    sessionStorage.removeItem('rowData');
    window.onafterprint = null;
  }
}
